
export default {
	state: {
		shoppingInfo: {}
	},
	mutations: {
		updateShopping(state, obj) {
            console.log(state, obj)
			state.shoppingInfo = obj
		}
	},
	getters:{
        getShoppingInfo(state){
            return state.shoppingInfo
        }
    },
	actions: {
        shoppingInfoAction:({commit}, obj)=>{
            console.log(obj, 'obj')
            commit("updateShopping")
        }
	}
}


// WEBPACK FOOTER //
// ./src/components/seckill/seckill.js